import React, { Fragment } from 'react';
import Submitted from '@/assets/submitted.png';
import { Header } from 'antd/lib/layout/layout';

function Page404() {
  return (
    <Fragment>
      <Header style={{ backgroundColor: 'white' }} className="header">
        <div className="logo" />
      </Header>

      <div className="header-banner"></div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '70%',
        }}
      >
        <img style={{ width: '124px' }} src={Submitted} alt="" />
        <span
          style={{
            fontFamily: 'Roboto Regular',
            fontSize: '12px',
            color: '#505050',
            marginTop: '12px',
          }}
        >
          Terima Kasih, Data Berhasil Disimpan
        </span>
      </div>
    </Fragment>
  );
}

export default Page404;
